import axios from 'axios';

export const systemService = {
    /** Service Type */
    createServiceGlobalService: (body) => axios.post(`/serviceType`, body, { auth: true }),

    getServicesService: (data) => axios.get(`/serviceType`, { auth: true, params: { ...data } }),

    editServiceByIdGlobalService: (id, body) => axios.patch(`/serviceType/${id}`, body, { auth: true }),

    deleteServiceByIdService: (id) => axios.delete(`/serviceType/${id}`, { auth: true }),
    /** End */

    /** Credentials */
    createCredentialGlobalService: (body) => axios.post(`/credential`, body, { auth: true }),

    createCoveredCredentialService: (id, body) => axios.post(`/credential/${id}/covered`, body, { auth: true }),

    editCoveredCredentialService: ({ credentialId, id, body }) =>
        axios.patch(`/credential/${credentialId}/covered/${id}`, body, { auth: true }),

    getCredentialGlobalService: (params) =>
        axios.get(`/credential`, {
            auth: true,
            params: {
                sortType: params?.sortType ? params?.sortType : 'name',
                orderType: params?.orderType ? params?.orderType : 'ASC',
            },
        }),

    editCredentialByIdGlobalService: (id, body) => axios.patch(`/credential/${id}`, body, { auth: true }),

    deleteCredentialByIdService: (id) => axios.delete(`/credential/${id}`, { auth: true }),
    /** End */

    /** Department */
    createDepartmentGlobalService: (body) => axios.post(`/department`, body, { auth: true }),

    getDepartmentsService: () => axios.get(`/department`, { auth: true }),

    editDepartmentByIdGlobalService: (id, body) => axios.patch(`/department/${id}`, body, { auth: true }),

    deleteDepartmentByIdService: (id) => axios.delete(`/department/${id}`, { auth: true }),
    /** End */

    /** Job */
    createJobGlobalService: (body) => axios.post(`/job/title`, body, { auth: true }),

    getJobsService: () => axios.get(`/job/title`, { auth: true }),

    editJobByIdGlobalService: (id, body) => axios.patch(`/job/title/${id}`, body, { auth: true }),

    deleteJobByIdService: (id) => axios.delete(`/job/title/${id}`, { auth: true }),
    /** End */

    /** Departments */
    createPlaceGlobalService: (body) => axios.post(`/place`, body, { auth: true }),

    getPlacesService: () => axios.get(`/place`, { auth: true }),

    editPlaceByIdGlobalService: (id, body) => axios.patch(`/place/${id}`, body, { auth: true }),

    deletePlaceByIdService: (id) => axios.delete(`/place/${id}`, { auth: true }),
    /** End */

    /** Company */
    createCompanyService: (body) => axios.post(`/company/profile`, body, { auth: true }),

    getCompanyService: () => axios.get(`/company/profile`, { auth: true }),

    editCompanyService: (id, body) => axios.patch(`/company/profile/${id}`, body, { auth: true }),

    deleteCompanyService: (id) => axios.delete(`/company/profile/${id}`, { auth: true }),

    getCompaniesService: () => axios.get(`/company/profile/all`, { auth: true }),

    getCompanyByNpi: (params) => axios.get(`/npi/lookup`, { auth: true, params: params }),
    /** End */

    /** Calendars */
    getConnectCalendarsService: () => axios.get(`/staff/calendars/state`, { auth: true }),

    disconnectCalendarService: (params) => axios.delete(`/staff/calendars`, { auth: true, params: params }),

    changeCalendarStatusService: (params) => axios.post(`/staff/calendars/state`, null, { auth: true, params: params }),

    /** App load: gives a Google calendar connected before zones were captured its zone; no-op on the API otherwise */
    detectGoogleCalendarTimeZoneService: (timeZone) => axios.post(`/staff/calendars/google/time-zone/detect`, { timeZone }, { auth: true }),
    /** End */

    /** Stripe */

    stripeSettingsService: (params) => axios.post(`/company/profile/integration-settings`, params, { auth: true }),

    /** End */

    /** Bank */
    createBankService: (body) => axios.post(`/bank`, body, { auth: true }),

    getBanksService: (data) => axios.get(`/bank`, { auth: true, params: { ...data } }),

    editBankService: (id, body) => axios.patch(`/bank/${id}`, body, { auth: true }),

    deleteBankService: (id) => axios.delete(`/bank/${id}`, { auth: true }),
    /** End */

    /** Supervision Config */
    getSupervisionConfigService: () => axios.get('/company/profile/supervision-config', { auth: true }),

    updateSupervisionConfigService: (body) => axios.put('/company/profile/supervision-config', body, { auth: true }),
    /** End */

    /** Clinical Settings */
    updateClinicalSettingsService: (body) => axios.put('/company/profile/clinical-settings', body, { auth: true }),
    /** End */

    /** Eligibility Auto-Check Config */
    getEligibilityAutoCheckConfigService: () => axios.get('/company/profile/eligibility-auto-check-config', { auth: true }),

    updateEligibilityAutoCheckConfigService: (body) => axios.put('/company/profile/eligibility-auto-check-config', body, { auth: true }),

    /** Members Portal Config */
    getMembersPortalConfigService: () => axios.get('/company/profile/members-portal-config', { auth: true }),

    updateMembersPortalConfigService: (body) => axios.put('/company/profile/members-portal-config', body, { auth: true }),

    runBatchEligibilityCheckService: () => axios.post('/clearinghouse/batch-eligibility', {}, { auth: true }),
    /** End */

    /** Ai Integration */

    changeAiIntegrationService: (params) => axios.post(`/company/profile/org-integration-settings`, params, { auth: true }),
    // changeAiIntegrationService: (params) => axios.post(`/company/profile/ai-integration-settings`, params,{ auth: true }),

    /** End */

    /** Integrations */

    getIntegrationsService: () => axios.get(`/clearinghouse/settings`, { auth: true }),

    connectIntegrationService: (body) => axios.post(`/clearinghouse/settings`, body, { auth: true }),

    disconnectIntegrationService: (isActive, type) =>
        axios.patch(`/clearinghouse/settings/status/${isActive}/clearinghouse/${type}`, {}, { auth: true }),

    editIntegrationService: (body) => axios.patch(`/clearinghouse/settings`, body, { auth: true }),

    canUseIntegrationService: () => axios.get(`/clearinghouse/settings/can-use`, { auth: true }),
    // canUseIntegrationService: () => axios.get(`/officeAlly/settings/can-use`, { auth: true }),

    deleteIntegrationService: () => axios.delete(`/officeAlly/settings`, { auth: true }),

    /** End */

    /** Zoom */

    getZoomAuthUrlZoomService: () => axios.get(`/zoom/authorize-url`, { auth: true }),

    connectZoomToTherapyService: (params) => axios.get(`/zoom/callback`, { auth: true, params: params }),

    editZoomStatusService: () => axios.patch(`/zoom/clinic/inactivate`, {}, { auth: true }),

    getMeetLink: (sessionId) => axios.get(`/meeting/start-url`, { auth: true, params: { sessionId: sessionId } }),

    copyMeetLink: (apptId) => axios.get(`/meeting/join-url`, { auth: true, params: { apptId: apptId } }),

    getActiveSessionService: (apptId) => axios.get(`/meeting/active`, { auth: true, params: { apptId: apptId } }),

    createZoomMeetingService: (body) => axios.post(`/meeting/create`, body, { auth: true }),

    deleteZoomMeetingService: (apptId) => axios.delete(`/meeting`, { auth: true, params: { apptId: apptId } }),

    getZoomUsersService: () => axios.get('/zoom/users', { auth: true }),

    /** End */

    /** Google Meet */

    getGoogleMeetAuthUrlService: () => axios.get('/google-meet/authorize-url', { auth: true }),

    connectGoogleMeetToTherapyService: (params) => axios.get('/google-meet/callback', { auth: true, params }),

    editGoogleMeetStatusService: () => axios.patch('/google-meet/clinic/inactivate', {}, { auth: true }),

    /** End */

    /** Telehealth */
    getTelehealthStatusService: () => axios.get('/meeting/telehealth-status', { auth: true }),
    /** End */

};
